"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Resolve social groups api base path depending on the `wixCodeApi.window.viewMode`
 * i.e. in Editor it would be `https://groups.wixapps.net/social-groups/api/`
 *
 * (see https://www.wix.com/corvid/reference/wix-window.html for more on `wixCodeApi.window`)
 */
function getBaseUrl(wixCodeApi) {
    return getApiBaseUrl(wixCodeApi.window.viewMode, wixCodeApi.location.baseUrl);
}
exports.default = getBaseUrl;
function getApiBaseUrl(viewMode, locationUrl) {
    var apiUrl = "/_api/social-groups/";
    switch (viewMode) {
        case undefined:
        case 'Standalone':
            return "" + window.location.origin + apiUrl;
        case 'Site':
            var url = new URL(locationUrl);
            return "" + url.origin + apiUrl;
        case 'dashboard':
        case 'editor':
            if (window.location.origin.includes('//localhost')) {
                return "" + window.location.origin + apiUrl;
            }
            return 'https://www.wix.com/social-groups/api/';
        default:
            return 'https://groups.wixapps.net/social-groups/api/';
    }
}
exports.getApiBaseUrl = getApiBaseUrl;
//# sourceMappingURL=baseUrl.js.map